<template>
  <div>
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-space-between>
        <v-flex class="pl-0">
          <food-tag-manage-modal
              @tag_stored="fetchData"
              @tag_closed="modalClosed()"
              :currentTag="currentTag"
              ref="tagModal"
          />
        </v-flex>
        <v-flex xs3 sm3 md3 d-flex>
          <v-combobox
              clearable
              :items="[
                  {text: trans('page.tags.diet'), value: 'diet'},
                  {text: trans('page.tags.equipment'), value: 'equipment'},
                  {text: trans('page.tags.meal'), value: 'meal'},
                  {text: trans('page.tags.tag'), value: 'tag'},
                ]"
              :label="trans('app.type')"
              v-model="filters.type"
              :return-object="true"
              hide-details
              solo
          ></v-combobox>
        </v-flex>
        <v-flex xs3 sm3 md3 d-flex>
          <v-text-field
              v-model="filters.search"
              append-icon="search"
              :label="trans('app.search.search')"
              single-line
              hide-details
              solo
              clearable
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table
        :headers="headers"
        :items="items"
        :pagination.sync="pagination"
        :total-items="total"
        :loading="isLoading"
        :rows-per-page-items="[10,25,50,100]"
        :no-data-text="trans('app.search.no_data')"
    >
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ `page.tags.${props.item.type}` | trans }}
          </td>
          <td class="justify-end layout px-0 pr-4">
            <icon-button
                icon="edit"
                color="success"
                cls="mr-0 ml-0"
                @click="editItem(props.item)"
                :tooltip="{top: true, bottom: false, attach: false}"
                :iconOptions="{small: true}"
            >
              {{ 'app.edit' | trans }}
            </icon-button>
            <icon-button
                icon="delete"
                color="red"
                cls="mr-0 ml-0"
                @click="deleteItem(props.item)"
                :tooltip="{top: true, bottom: false, attach: false}"
                :iconOptions="{small: true}"
            >
              {{ 'app.delete' | trans }}
            </icon-button>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2 pb-4">
      <v-pagination v-model="pagination.page" total-visible=10 :length="pages"></v-pagination>
    </div>
  </div>
</template>
<script>
import {trans} from "../app";
import {stringify} from "qs";
import debounce from "lodash/debounce";

export default {
  data: function() {
    return {
      headers: [
        {
          text: trans('app.name'), align: 'left', value: 'name', sortable: true,
        },
        {
          text: trans('app.type'), align: 'left', value: 'type', sortable: false,
        },
        {
          text: '', align: 'center', value: '', sortable: false,
        },
      ],
      items: [],
      pagination: {
        rowsPerPage: 50,
        sortBy: 'name',
        descending: false,
      },
      pages: 0,
      total: 0,
      isLoading: true,
      filters: {
        search: null,
        type: null,
      },
      currentTag: null,
    }
  },
  created() {
    this.debounceFetch = debounce(this.fetchData, 300);
  },
  mounted() {
    this.debounceFetch();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      const {sortBy, descending, page, rowsPerPage} = this.pagination;

      const query = {
        page: page,
        perPage: rowsPerPage,
        orderBy: sortBy,
        dir: descending ? 'desc' : 'asc',
        ...this.filters,
      };

      if (this.filters.type) {
        query.type = this.filters.type.value;
      }

      const response = await axios.get(`/v2/food-tags?${stringify(query, {skipNulls: true})}`);
      const {data, meta} = response.data;
      this.items = data;
      this.total = meta.total;
      this.pages = meta.last_page;
      this.isLoading = false;
    },
    editItem(item) {
      this.currentTag = item;
      this.$refs.tagModal.open();
    },
    modalClosed() {
      this.currentTag = null;
    },
    deleteItem(item) {
      this.$confirmDanger(
          trans('app.confirm_removal'),
          trans('app.remove') + ' ' + trans('app.tags.tags').toLowerCase()
      ).then(async () => {
        await axios.delete('/v2/food-tags/' + item.id);
        await this.fetchData();
        this.$toast(trans('app.removed'));
      }).catch((error) => {
        this.sentryCaptureException(error);
      })
    }
  },
  watch: {
    pagination: {
      handler(newValue, oldValue) {
        if (oldValue.page !== undefined) {
          this.fetchData();
        }
      },
      deep: true,
    },
    filters: {
      handler() {
        this.debounceFetch();
      },
      deep: true,
    },
  }
}
</script>
